import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Badge, Icon } from 'antd';

const NotificationIcon = ({
  icon, classes, showBadge, badgeCount, active, onClick
}) => (
  <div className={classNames(classes, { 'bhp-active': active })} onClick={() => onClick()}>
    <Icon type={icon} style={{ fontSize: '18px' }} />
    {showBadge && (<Badge showZero overflowCount={5} offset={[-5, -5]} count={badgeCount} />)}
  </div>
);

NotificationIcon.propTypes = {
  classes: PropTypes.string,
  icon: PropTypes.string.isRequired,
  showBadge: PropTypes.bool,
  badgeCount: PropTypes.number,
  active: PropTypes.bool,
  onClick: PropTypes.func
};

NotificationIcon.defaultProps = {
  classes: '',
  showBadge: true,
  badgeCount: 0,
  active: false,
  onClick() {
  }
};

export default NotificationIcon;
